import api from './api';
import {
  Invoice,
  InvoiceStats,
  CreateInvoiceData,
  RecordPaymentData,
  InvoiceFilters,
  BrokerageQueueLead,
  InvoiceCalculation,
  Payment,
} from '@/types/invoice.types';
import { PaginatedResponse, InvoiceResponse } from '@/types';

export const invoicesService = {
  // Get all invoices with filters and pagination
  getAll: (filters?: InvoiceFilters, page = 1, limit = 20) =>
    api.get<PaginatedResponse<Invoice>>('/invoices', {
      params: { ...filters, page, limit },
    }),

  // Get single invoice by ID - returns { invoice: {...} }
  getById: (id: string) => api.get<InvoiceResponse>(`/invoices/${id}`),

  // Get invoice statistics - returns stats directly (after interceptor unwrap)
  getStats: () => api.get<InvoiceStats>('/invoices/stats'),

  // Get leads ready for brokerage invoicing - returns { leads: [...] }
  getBrokerageQueue: () =>
    api.get<{ leads: BrokerageQueueLead[] }>('/invoices/brokerage-queue'),

  // Create new invoice
  create: (data: CreateInvoiceData) => api.post<Invoice>('/invoices', data),

  // Record a payment against an invoice
  recordPayment: (id: string, data: RecordPaymentData) =>
    api.post<Payment>(`/invoices/${id}/payments`, data),

  // Cancel an invoice
  cancel: (id: string, reason: string) =>
    api.post(`/invoices/${id}/cancel`, { reason }),

  // Calculate invoice amounts (preview before creating)
  calculate: (data: Partial<CreateInvoiceData>) =>
    api.post<InvoiceCalculation>('/invoices/calculate', data),
};

export default invoicesService;
